import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { Permission } from '@server/permissions';
import { usePermissions } from './usePermissions';

const useCrmOrgPermissions = (permissionArray: Permission[], crmOrgId?: string) => {
  const { checkPermissions } = usePermissions();

  const defaultCrmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const effectiveCrmOrgId = crmOrgId ?? defaultCrmOrgId ?? '';

  return checkPermissions(permissionArray, effectiveCrmOrgId);
};

export default useCrmOrgPermissions;
